<template>
  <transition key="modal" name="modal">
    <div class="modal-mask bidding-increment-modal">
      <div class="modal-wrapper">
        <div class="modal-container modal-center employees-modal">
          <slot name="header">
            <button
              id="hide-modal"
              class="btn-oval btn-oval--transparent modal__close"
              @click="$emit('close')"
              >
              <span class="icon icon-close-big"></span>
            </button>
            <span class="headings--h3">
              {{ I18n.t("employees.results.auctions_catalogs.artworks.form.title") }}
            </span>
          </slot>
          <slot name="body">
            <EditAuctionForm
              :auction="auction"
              :auctionsCatalog="auctionsCatalog"
              v-on:close-edit-modal="$emit('close')"/>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import EditAuctionForm from './form';

  export default {
    name: 'Modal',
    props: {
      auction: Object,
      auctionsCatalog: Object,
    },
    components: {
      EditAuctionForm,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/artworks/modal.vue?5abfd53d